/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'

export const _3 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>3 - CSS фильтры</h2>
    <p className={styles.description}>
      Свойство <code className={styles.code}>filter</code> позволяет применять к элементу графические эффекты, такие как
      размытие или изменение цвета. Фильтры обычно используются для настройки рендеринга изображений, фона и границ.{' '}
    </p>
    <p className={styles.description}>
      Возможные значения: <code className={styles.code}>blur</code>, <code className={styles.code}>brightness</code>,{' '}
      <code className={styles.code}>contrast</code>, <code className={styles.code}>grayscale</code>,{' '}
      <code className={styles.code}>hue-rotate</code>, <code className={styles.code}>invert</code>,{' '}
      <code className={styles.code}>opacity</code>, <code className={styles.code}>saturate</code>,{' '}
      <code className={styles.code}>sepia</code>.{' '}
    </p>
    <p className={styles.description}>
      В примере показано действие каждого из значений свойства <code className={styles.code}>filter</code>. Диапазон
      значений указан в атрибутах тега <code className={styles.code}>input</code>.
    </p>
  </section>
))
